export default __webpack_public_path__ + "static/media/SilverFoilRocket_03.2322508e.png";